// extracted by mini-css-extract-plugin
module.exports = {"root":"SnackRemains_root__3YKPG","cells":"SnackRemains_cells__EtdLC","remainValues":"SnackRemains_remainValues__LtOvr"};